export default __webpack_public_path__ + "static/media/ChallengeCompleteColor.3b984f74.png";